export default __webpack_public_path__ + "static/media/LOA_Vanquis_till_30_10_2024.3e4b1d3f.pdf";